import React from "react";
import PropTypes from "prop-types";
import "./App.css";
import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/404.css";
import UsersRoute from "./routes/UsersRoute";
import AdminRoute from "./routes/AdminRoute";
import Route403 from "./routes/Route403";
import ReactLoading from "react-loading";
import { connect } from "react-redux";
import keycloak from "./keycloak";

const LOGIN_REQUIRED = "login-required";
const ADD_POST = "ADD_POST";
const SPIN = "spin";
const INITIALIZING_KEYCLOAK = "Initializing Keycloak...";
const SER_URL_PREFIX = "/ser/";

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      keycloak: null,
      authenticated: null,
      token: null,
      admin_role: null,
      user_role: null,
      username: null,
      xdr: null,
      xdr_edr: null,
      xdr_soar: null,
      xdr_cm: null,
      xdr_tm: null,
      compliance_gsos: null,
      xdrp_nd: null,
      xdrp_pm: null,
      xdrp: null,
      oxdr: null,
      compliance: null,
      oxdr_asm: null,
      oxdr_bas: null,
      oxdr_ro: null,
      oxdr_vm: null,
      oxdr_phish: null,
      configuration_role: null,
    };
  }

  dispatchActions() {
    const {
      username,
      keycloak,
      authenticated,
      admin_role,
      user_role,
      xdr,
      xdr_edr,
      xdr_soar,
      xdr_cm,
      xdr_tm,
      compliance_gsos,
      xdrp_nd,
      xdrp_pm,
      xdrp,
      oxdr,
      compliance,
      id_token,
      realm,
      oxdr_asm,
      oxdr_bas,
      oxdr_ro,
      oxdr_vm,
      oxdr_phish,
      configuration_role,
    } = this.state;

    this.props.dispatch({
      type: ADD_POST,
      payload: {
        username,
        keycloak,
        authenticated,
        admin_role,
        user_role,
        xdr,
        xdr_edr,
        xdr_soar,
        xdr_cm,
        xdr_tm,
        compliance_gsos,
        xdrp_nd,
        xdrp_pm,
        xdrp,
        oxdr,
        compliance,
        id_token,
        realm,
        oxdr_asm,
        oxdr_bas,
        oxdr_ro,
        oxdr_vm,
        oxdr_phish,
        configuration_role
      },
    });
  }

  componentDidMount() {
    keycloak.init({ onLoad: LOGIN_REQUIRED,checkLoginIframe: false, enableLogging: true, }).then((authenticated) => {
      this.setState({
        keycloak: keycloak,
        authenticated: authenticated,
        admin_role: keycloak.hasRealmRole("admin"),
        configuration_role: keycloak.hasRealmRole("configuration"),
        user_role: keycloak.hasRealmRole("user"),
        xdr: keycloak.hasRealmRole("xdr"),
        xdr_edr: keycloak.hasRealmRole("xdr_edr"),
        xdr_soar: keycloak.hasRealmRole("xdr_soar"),
        xdr_cm: keycloak.hasRealmRole("xdr_cm"),
        xdr_tm: keycloak.hasRealmRole("xdr_tm"),
        compliance_gsos: keycloak.hasRealmRole("compliance_gsos"),
        xdrp_nd: keycloak.hasRealmRole("xdrp_nd"),
        xdrp_pm: keycloak.hasRealmRole("xdrp_pm"),
        oxdr_asm: keycloak.hasRealmRole("oxdr_asm"),
        oxdr_bas: keycloak.hasRealmRole("oxdr_bas"),
        oxdr_ro: keycloak.hasRealmRole("oxdr_ro"),
        oxdr_vm: keycloak.hasRealmRole("oxdr_vm"),
        oxdr_phish: keycloak.hasRealmRole("oxdr_phish"),
        xdrp: keycloak.hasRealmRole("xdrp"),
        oxdr: keycloak.hasRealmRole("oxdr"),
        compliance: keycloak.hasRealmRole("compliance"),
        username: keycloak.idTokenParsed.name,
        id_token: keycloak.idToken,
        realm: keycloak.realm,
        token: keycloak.token,
      });
      
      // Action to dispatch everything into Redux
      this.dispatchActions();
    });

    keycloak.onTokenExpired = () => {
      keycloak
        .updateToken(50)
        .success((refreshed) => {
          if (refreshed) {
            sessionStorage.setItem("authentication", keycloak.token);
          } else {
            console.error("token not refreshed " + new Date());
          }
        })
        .error(() => {
          window.location =
            process.env.REACT_APP_KEYCLOAK_URL +
            "/realms/" +
            this.state.realm +
            "/protocol/openid-connect/logout?" +
            "post_logout_redirect_uri=" +
            window.location.origin +
            "&id_token_hint=" +
            this.state.id_token;
          console.error("Failed to refresh token " + new Date());
        });
    };
  }

  render() {
    const { keycloak, authenticated, user_role, admin_role, token } = this.state;
    sessionStorage.setItem("authentication", token);

    let adminBlock = (
      <div className="App">
        <AdminRoute />
      </div>
    );

    if (keycloak && authenticated) {
      if (user_role && admin_role) {
        return adminBlock;
      } else if (user_role) {
        return (
          <div className="App">
            <UsersRoute />
          </div>
        );
      } else if (admin_role) {
        return adminBlock;
      } else {
        return (
          <div className="App">
            <Route403 />
          </div>
        );
      }
    }
    else {
      return (
        <div className={SPIN}>
          <ReactLoading type={"spin"} color={"#000000"} height={"10%"} width={"15%"} />
          <div>{INITIALIZING_KEYCLOAK}</div>
        </div>
      );
    }
    
  }
}

// PropTypes for dispatch function
App.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(App);
